import {
  SET_SUBMITTING_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  SET_VIRTUAL_ENTRY_BOWLER_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  SET_VIRTUAL_ENTRY_TEAM_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  SET_DETAILS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  SET_AVAILABLE_BOWLERS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  SET_AVAILABLE_TEAMS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  SET_VIRTUAL_ENTRIES_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL,
  SET_VIRTUAL_ENTRY_SELECTED_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL,
  DISPLAY_PAYMENT_MODAL_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL,
  SET_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL,
  SET_REFUND_TYPE_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL,
  DISPLAY_CAPTAIN_VIRTUAL_ENTRY_CHANGE_MODAL_FOR_ADMIN,
  SET_IS_NEW_CAPTAIN_VIRTUAL_ENTRIES_MODAL_FOR_ADMIN,
  SET_VIRTUAL_EVENT_DETAIL_CREDIT_PURCHASE_TRANSACTIONS
} from './constants'; 

export const initialState = {
  balance: 0,
  virtualEventId: '',
  vitualEventName: '',
  captainId: '',
  captainName: '',
  virtualEntries: null,
  bowlers: [],
  teams: [],
  submitting: false,
  selectedBalance: 0,
  paymentModalType: 'Payment',
  refundType: 'refundOnly',
  selectedVirtualEntries: [],
  hasSelectedVirtualEntries: false,
  showCaptainVirtualEntryChangeModal: false,
  isNewCaptainOnSearch: false
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_SUBMITTING_FOR_ADMIN_VIRTUAL_EVENT_DETAIL:
      return {
        ...state,
        submitting: payload || initialState.submitting
      };
    case SET_VIRTUAL_ENTRY_BOWLER_FOR_ADMIN_VIRTUAL_EVENT_DETAIL:
    case SET_VIRTUAL_ENTRY_TEAM_FOR_ADMIN_VIRTUAL_EVENT_DETAIL: 
    case SET_VIRTUAL_ENTRY_SELECTED_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL: {
      const newVirtualEntries = state.virtualEntries.map(x => virtualEntryReducer(x, {type, payload}));
      const selectedVirtualEntries = newVirtualEntries.filter(entry => entry.selected);
      const hasSelectedVirtualEntries = newVirtualEntries.some(entry => entry.selected);

      return {
        ...state,
        virtualEntries: newVirtualEntries,
        selectedVirtualEntries,
        hasSelectedVirtualEntries
      };
    }
    case SET_DETAILS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL:
      return {
        ...state,
        ...(payload || {})
      };
    case SET_AVAILABLE_BOWLERS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL:
      return {
        ...state,
        bowlers: payload || initialState.bowlers
      };
    case SET_AVAILABLE_TEAMS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL:
      return {
        ...state,
        teams: payload || initialState.teams
      };
    case SET_VIRTUAL_ENTRIES_FOR_ADMIN_VIRTUAL_EVENT_DETAIL: {
      let virtualEntries = initialState.virtualEntries;
      let selectedBalance = 0;
      let balance = 0;

      if (payload) {
        virtualEntries = payload.map(x => ({
          ...x,
          selected: false
        }));

        balance = virtualEntries.reduce((sum, virtualEntry) => sum + virtualEntry.balance, 0);
      }
      return {
        ...state,
        balance,
        virtualEntries,
        selectedBalance
      };
    }
    case CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL: {
      const selectedBalance = state.virtualEntries
        .filter(virtualEntry => virtualEntry.selected)
        .reduce((sum, virtualEntry) => sum + virtualEntry.balance, 0);

      return {
        ...state,
        selectedBalance
      };
    }
    case SET_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL: {
      return {
        ...state,
        selectedBalance : payload
      };
    }
    case DISPLAY_PAYMENT_MODAL_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL:
      return {
        ...state,
        showPaymentModal: payload.showModal || initialState.showPaymentModal,
        paymentModalType: payload.paymentModalType || initialState.paymentModalType
        };
    case SET_REFUND_TYPE_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL: {
      return {
        ...state,
        refundType: payload
      };
    }
    case DISPLAY_CAPTAIN_VIRTUAL_ENTRY_CHANGE_MODAL_FOR_ADMIN: {
      return {
        ...state,
        showCaptainVirtualEntryChangeModal: payload 
      };
    } 
    case SET_IS_NEW_CAPTAIN_VIRTUAL_ENTRIES_MODAL_FOR_ADMIN: {
      return {
        ...state,
        isNewCaptainOnSearch: payload 
      };
    }
    case SET_VIRTUAL_EVENT_DETAIL_CREDIT_PURCHASE_TRANSACTIONS: {
      return {
        ...state,
        creditPurchaseTransactions: payload
      };
    }
    default:
      return state;
  }
};

const virtualEntryReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case SET_VIRTUAL_ENTRY_BOWLER_FOR_ADMIN_VIRTUAL_EVENT_DETAIL:
      return payload && payload.virtualEntryId === state.id
        ? {
          ...state,
          bowlerId: payload.bowlerId
        }
        : state;
    case SET_VIRTUAL_ENTRY_TEAM_FOR_ADMIN_VIRTUAL_EVENT_DETAIL:
    return payload && payload.virtualEntryId === state.id
        ? {
          ...state,
          entryId: payload.entryId
        }
        : state;
    case SET_VIRTUAL_ENTRY_SELECTED_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL:
      return payload === state.id
        ? {
          ...state,
          selected: !state.selected
        }
        : state;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/admin/virtualEventDetail/reducer.js